import { v2OptionStatsService } from '../services/v2OptionStats.service';

import { DateTime } from 'luxon';

const state = {
  dates: null,
  creatorData: null,
  industryData: null,
  senderData: null,
  senderIndustryData: null,
  shareOptionsData: null,
  loading: true,
  lastUpdated: null,
  lastUpdatedDiff: null
};

const actions = {
  setDates({ commit }, dates) {
    commit('changeDates', { dates });
  },

  getData({ dispatch, commit, state }) {
    commit('setLoadingState', true);
    const dates = {start_date: state.dates.startDate, end_date: state.dates.endDate};
    Promise.all([
      v2OptionStatsService.getStatisticsByCreator(dates),
      v2OptionStatsService.getStatisticsByIndustry(dates),
      v2OptionStatsService.getStatisticsBySender(dates),
      v2OptionStatsService.getStatisticsBySenderIndustry(dates),
      v2OptionStatsService.getShareOptionsBySender(dates)
    ])
      .then(res => {
        commit('changeData', {
          creatorData: res[0].data,
          industryData: res[1].data,
          senderData: res[2].data,
          senderIndustryData: res[3].data,
          shareOptionsData: res[4].data
        });
        commit('setLastUpdated');
        commit('setLoadingState', false);
        dispatch('setLastUpdatedTimeInterval');
      })
      .catch(() => dispatch('alert/error', 'Unable to get option data', { root: true }));
  },

  setLastUpdatedTimeInterval({ commit }) {
    const intervalId = setInterval(() => {
      commit('setLastUpdatedDiff');
    }, 1000);
    commit('changeIntervalId', intervalId);
  },

  unsetInterval({ state, commit }) {
    clearInterval(state.lastUpdatedInterval);
    commit('changeIntervalId', null);
  }
};

const mutations = {
  changeDates(state, payload) {
    state.dates = payload.dates;
  },

  changeData(state, payload) {
    Object.assign(state, payload);
  },

  setLoadingState(state, payload) {
    state.loading = payload;
  },

  setLastUpdated(state) {
    state.lastUpdated = DateTime.local();
  },

  setLastUpdatedDiff(state) {
    state.lastUpdatedDiff = state.lastUpdated.diffNow().as('seconds');
  },

  changeIntervalId(state, payload) {
    state.lastUpdatedInterval = payload;
  }
};

export const options = {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/options.module.js